const fa = {
  10000001: 'SuperEx جشن دو سالگی',
  10000002: 'برای جوایز عالی وارد شوید!',
  10000003: 'با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 10000 USDT بزرگتر باز می شود.',
  10000004: 'جشن دو سالگی SuperEx',
  10000005: 'برنده 20000 USDT در رقابت معاملات آتی',
  10000006: 'رویداد  حجم معاملات: بالاترین جایزه <span style="color: #ffc72b;">10,000</span> USDT را باز کنید.',
  10000007: 'قهرمانی آینده',
  10000008: 'در رقابت معاملات آتی USDT برنده 20000',

  10000009: 'انتخاب کنید',
  10000010: 'کل عرضه',
  10000011: 'جستجوگر',
  10000012: 'برگشت',
  10000013: 'بعدی',
  10000014: 'قبلی',
  10000015: 'اطلاعات را پر کنید',
  10000016: 'لطفاً نام توکن را وارد کنید',
  10000017: 'لطفا نام کامل توکن را وارد کنید.',
  10000018: 'فهمیدم',
  10000019: 'لطفاً نام نمونه جفت معاملاتی را وارد کنید.',
  10000020: 'لطفا ساپلای در گردش توکن را ارائه دهید.',
  10000021: 'انجام شد',
  10000022: 'پس از آن، می‌توانید داده‌های آماری مربوط به جفت معاملاتی را در صفحه بازار آزاد وب‌سایت مشاهده کنید.',
  10000023: 'در صرافی لیست شده {currency}',
  10000024: 'سال',
  10000025: 'ماه',
  10000026: 'روز',

  8000067: 'آمار',
  8000068: 'نام توکن',
  8000069: 'زنجیره اصلی یا پروتکل',
  8000070: 'آدرس قرارداد یا تیکر',
  8000071: 'نام نمونه',
  8000072: 'زمان ایجاد نمونه',
  8000073: 'وضعیت نمونه',
  8000074: 'مبلغ کمیسیون (تجمیع)/U',
  8000075: 'مبلغ کمیسیون (هفته گذشته)/U',
  8000076: 'مبلغ تراکنش (هفته گذشته)/U',
  8000077: 'تعداد معاملات (هفته گذشته)',
  8000078: 'یک جفت معاملاتی ایجاد کنید',
  8000079: 'توسعه',
  8000080: 'ذکر شده',
  8000081: 'از لیست حذف شود',
  8000082: 'از فهرست حذف شد',
  8000083: 'توکن را انتخاب کنید',
  8000084: 'اعلان فهرست',
  8000085: 'با موفقیت ایجاد شد',
  8000086: 'فهرست کردن در بازار آزاد',
  8000087: 'در SuperEx، شما می‌توانید به راحتی و رایگان لیستینگ‌های صرافی را کامل کنید و فرصت دریافت تا 80 درصد از سود تقسیم شده هزینه‌های تجارتی را داشته باشید.',
  8000088: 'چگونه کار می‌کند?',
  8000089: 'یک جفت معاملاتی جدید ایجاد کنید',
  8000090: 'من قصد دارم سکه را لیست کنم.',
  8000091: 'یک نمونه جفت معاملاتی ایجاد کنید',
  8000092: 'صرافی SuperEx',
  8000093: 'چرا ما را انتخاب کنید؟',
  8000094: 'انتخاب های متنوع',
  8000095: 'پشتیبانی از چندین زنجیره و پروتکل، شامل زنجیره BSC، زنجیره ETH و زنجیره SOL.',
  8000096: 'فهرست فوری بدون تأیید دستی مانند فرآیند غیرمتمرکز، و از راحتی تجارت کتاب سفارش لذت ببرید.',
  8000097: 'پشتیبانی از API.',
  8000098: 'شما می‌توانید از اینترفیس API برای انجام معاملات یا بازارسازی استفاده کنید که عملیات شما را کارآمدتر و خودکارتر می‌کند.',
  8000099: 'قرار گرفتن در معرض دید و ترافیک',
  8000100: 'با لیست شدن در Free Market، از ترافیک بالای کاربران SuperEx بهره‌مند شوید و توجه بیشتری را به دست آورید.',
  8000101: 'چه مبتدی یا یک معامله گر با تجربه باشید اسپات  ما تجربیات و فرصت های سرمایه گذاری جدیدی را برای شما به ارمغان می آورد. فورا جفت های معاملاتی خود را ایجاد کنید، سکه های میم مورد علاقه خود را تبلیغ کنید و از درآمد کمیسیون از کارمزد معاملات لذت ببرید!',
  8000102: ' قبل از اینکه واجد شرایط ایجاد یک جفت معاملاتی باشید، مجموع دارایی های شما باید از {resultData} USDT بیشتر باشد.',
  8000103: 'فهرست کردن رمز مورد علاقه شما',
  8000104: 'می‌توانید ارز دیجیتال مورد نظر خود را انتخاب کنید و آن را با USDT جفت کنید تا یک جفت معاملاتی منحصر به فرد ایجاد کنید.',
  8000105: 'دریافت هزینه کمیسیون',
  8000106: 'هنگامی که حجم معاملات یک نمونه جفت معاملاتی که ایجاد کرده اید به آستانه مشخصی برسد، بخشی از کارمزد تراکنش به عنوان کمیسیون به شما بازگردانده می شود. این به شما این امکان را می دهد که به عنوان خالق نمونه جفت معاملاتی، در سود معاملات نیز شریک شوید.',
  8000107: 'اکنون شما یک کاربر محدود هستید و به طور موقت قادر به ایجاد جفت معاملاتی جدید نیستید. لطفا فردا دوباره امتحان کنید.',
  8000108: 'لطفا یک زبان را انتخاب کنید',
  8000109: 'وایت پیپر',
  8000110: 'توکن در لیست ممنوع شده است!',
  8000111: 'این توکن قبلاً در تابلو اصلی سوپراکس فهرست شده است و شما نمی توانید جفت معاملاتی دیگری ایجاد کنید!',
  8000112: 'لطفا یک آدرس قرارداد معتبر / تیکر وارد کنید!',
  8000113: 'موجودی ET شما در برد اصلی Spot کافی نیست. برای ایجاد یک نمونه جفت تجاری جدید، باید هزینه مدیریتی {num} ET را پرداخت کنید. لطفاً مجدداً شارژ کنید و دوباره امتحان کنید',
  8000114: 'امروز در طول فرآیند ایجاد یک جفت معاملاتی جدید، ورودی های نادرست زیادی ایجاد کرده اید. بنابراین، امروز دیگر نمی توانید درخواست ارسال کنید. لطفا فردا دوباره امتحان کنید.',
  8000115: 'رمز از قبل وجود دارد، بنابراین اکنون یک نمونه جدید از جفت معاملاتی برای شما ایجاد خواهیم کرد!',
  8000116: 'لطفا اطلاعات زیر را تایید کنید: ',
  8000117: 'دزیمال اعشاری مقدار توکن',
  8000118: 'چگونه یک سکه را به صورت آزاد فهرست کنیم',
  8000119: 'نام کامل ارز',
  8000120: 'دزیمال اعشاری قیمت توکن',
  8000121: 'لیست شدن سکه در SUPEREX:<em class="normal" style="color: #0CAA6D;">بدون هزینه لیست شدن! </em><em class="normal" style="color: #1D90F5;">بدون هزینه ارتباطات! </em>در عرض 1 دقیقه لیست شدن در صرافی را کامل کنید و از سوددهی تا <em class="normal" style="color: #F65D62;">80%</em> لذت ببرید',
  8000122: 'معرفی رمز به زبان انگلیسی',
  8000123: 'اطلاعات زیر مورد نیاز است:',
  8000124: 'نام نمونه ای که وارد کردید از قبل وجود دارد. لطفا یکی دیگر را وارد کنید.',
  8000125: 'موارد زیر اطلاعات اختیاری هستند:',
  8000126: 'لطفاً زنجیره اصلی یا پروتکل و هزینه مدیریت مربوطه را انتخاب کنید.',
  8000127: 'مرحله 1: آدرس قرارداد سکه جدید را کپی و پیست کنید.',
  8000128: 'لطفا آدرس قرارداد / تیکر را وارد کنید.',
  8000129: 'تایید',
  8000130: 'نمونه شما از جفت معاملاتی {currency} با موفقیت ایجاد شد!',
  8000131: 'مرحله 2: اگر این سکه برای اولین بار در صرافی ما لیست می‌شود، شما باید چند جزئیات اساسی را کامل کنید، مانند معرفی سکه و آپلود تصویر لوگو',
  8000132: 'بازارهای پروتکل BTC',
  8000133: 'مرحله 3: شما فقط باید نمونه این جفت تجاری که ایجاد کرده‌اید را نامگذاری کنید. سپس، فرآیند لیستینگ کامل می‌شود و این سکه به صورت عمومی معامله می‌شود',
  8000134: 'فهرست کردن توکن‌ها',
  8000135: 'لطفا کل عرضه را وارد کنید.',
  8000136: 'مرحله 4: هنگامی که حجم تجارت هفتگی نمونه شما به یک آستانه مشخص برسد، شما قسمتی از هزینه‌های تجارتی از این نمونه را دریافت خواهید کرد.',
  8000137: 'اگر 2 را انتخاب کنید، به این معنی است که نمایش عددی قیمت توکن شما 0.01 است. به عنوان مثال، قیمت بیت کوین به صورت 72156.78 دلار نمایش داده می شود. برای اکثر توکن های ، توصیه می کنیم 11 را انتخاب کنید.',
  8000138: 'لطفا وارد شوید',
  8000139: 'من قصد دارم لیست کردن سکه را شروع کنم.',
  8000140: 'لطفاً توضیح مختصری از توکن به زبان انگلیسی وارد کنید.',
  8000141: 'شما می‌توانید "اینستنس" را به سادگی به عنوان نسخه‌های مختلف یک جفت معاملاتی مشابه درک کنید که یکی از این نسخه‌ها اینستنس ایجاد شده توسط شماست. سایر کاربران این نسخه‌ها را از طریق نام اینستنس‌ها تفکیک می‌کنند. هرگاه کاربران اینستنس شما را برای معامله انتخاب کنند، شما فرصتی برای دریافت کمیسیون کارمزد معامله خواهید داشت.',
  8000142: 'فرمت ایمیل نادرست است.',
  8000143: 'لطفا آدرس درخواست بلاکچین را وارد کنید.',
  8000144: 'عرضه در گردش',
  8000145: 'عرضه در گردش محدود به 1-20 رقم به عنوان یک عدد صحیح مثبت است.',
  8000146: 'نماد توکن',
  8000147: 'از فرمت‌های PNG یا JPG پشتیبانی می‌شود، محدودیت حجم فایل ۵ مگابایت است و می‌توانید روزانه تا ۱۰ بار بارگذاری کنید.',
  8000148: 'تاریخ صدور',
  8000149: 'لطفا تاریخ صدور را انتخاب کنید.',
  8000150: 'لطفا لینک وایت پیپر را ارائه دهید.',
  8000151: 'وب سایت رسمی',
  8000152: 'لطفا لینک وب سایت رسمی را ارائه دهید.',
  8000153: 'فهرست بازار آزاد',
  8000154: 'در حال فهرست شدن توکن شما در صرافی',
  8000155: 'محدودیت ورودی برای نام توکن ۹ کاراکتر است و فقط اعداد، حروف انگلیسی و نمادهای انگلیسی پشتیبانی می‌شون',
  8000156: 'محدودیت ورودی برای نام کامل توکن ۵۰ کاراکتر است و فقط اعداد، فاصله‌ها، حروف انگلیسی و نمادهای انگلیسی پشتیبانی می‌شون',
  8000157: 'عرضه کل باید یک عدد صحیح مثبت با 1 تا 20 رقم باشد.',
  8000158: 'از زبان‌های مختلف، علائم نگارشی، اعداد و فضاها پشتیبانی می‌کند. کاراکتر اول یا آخر نمی‌تواند فضای خالی باشد و نباید فضاهای خالی پیوسته وجود داشته باش',
  8000159: '1. صادرکننده مسئول صحت اطلاعات است و پلتفرم این حق را برای خود محفوظ می‌دارد که در هر زمان نشانه‌ها یا نمونه‌های جفت معامله را از فهرست حذف کند و محتوای اطلاعات را در هر زمان تنظیم کند.',
  8000160: '2. ناشر موظف است تحقیقات کاملی در مورد توکن فهرست شده انجام دهد و مسئولیت معقول بودن، مطابقت و قانونی بودن آن را بر عهده بگیرد. اگر پلتفرم هر گونه رفتار یا محتوای مخرب یا مضر یا سایر رفتارها یا محتوای خاص را در قرارداد هوشمند توکن شناسایی کند، توکن را مستقیماً از فهرست حذف می‌کند و کاربران را در ادعای ادعایی علیه صادرکننده نمایندگی می‌کند.',
  8000161: '3. اگر صادرکننده یا هر شخص دیگری بخواهد بعداً اطلاعات رمز را اصلاح کند، باید با خدمات مشتری ما تماس بگیرد.',
  8000162: '4. برای محافظت از منافع کاربران و حذف توکن‌های بی‌کیفیت، اگر نمونه جفت معاملاتی ایجاد شده توسط ناشر الزامات فعالیت معاملاتی پلتفرم ما را برآورده نکند، تقریباً یک هفته بعد به صادرکننده اطلاع داده می‌شود که از فهرست خارج شود. هر دوشنبه، این پلتفرم اعلان‌های حذف از فهرست را از طریق ایمیل و اعلان‌های برنامه برای مواردی که مطابقت ندارند برای صادرکنندگان ارسال می‌کند. و صادرکنندگان این فرصت را خواهند داشت که ظرف 5 روز برای تمدید فهرست درخواست دهند. در صورت موفقیت آمیز بودن درخواست 4 هفته زمان مشاهده اضافی اعطا خواهد شد. در غیر این صورت ارز ها از فهرست حذف خواهند شد.',
  8000163: '5. "اگر نمونه جفت معاملاتی ایجاد شده توسط صادرکننده توکن به حد نصاب سود پلتفرم برای حجم معاملات برسد، سود مربوط به کارمزدها را دریافت خواهند کر',
  8000164: 'آیا مایلید مقدار مشخصی از توکن‌ها را برای فعالیت‌های عملیاتی و بازاریابی، به منظور گسترش تأثیر سکه ارائه دهید؟',
  8000165: '6. صادرکننده می‌تواند با خدمات مشتریان ما تماس بگیرد تا برای Market Maker درخواست دهد.',
  8000166: 'ايجاد كردن',
  8000167: 'شما در حال ایجاد یک نمونه از جفت تجاری {currency} هستید و {upFee} ET از حساب اصلی اسپات شما کسر خواهد شد.',
  8000168: 'نه',
  8000169: 'بله',
  8000170: 'لطفاً آدرس ایمیل خود را وارد کنید تا تیم عملیات بازاریابی ما با شما تماس بگیرد',
  8000171: 'آیا فرد معرفی کننده یا شخص تماس دارید؟',
  8000172: 'لطفاً نام یا اطلاعات تماس معرف را وارد کنید.',
  8000173: ' با کلیک بر روی این چک‌باکس، شما تمامی ریسک‌های مرتبط را تأیید کرده و با <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">شرایط و ضوابط</a> ما موافقت می‌کنی.',
  8000174: 'سود از لیست کردن',
  8000175: 'حق لیست کردن در یک صرافی',
  8000176: 'این توکن در حال حاضر برای لیست شدن پشتیبانی نمی‌شود!',
  8000177: 'اطلاعات را پر کنید',
  8000178: ' برو به اشتراک بگذار',
  8000179: 'در صرافی لیست شده!',
  8000180: 'بازار آزاد SuperEx، دنیای رمزارزی از کاربران، توسط کاربران، برای کاربران',
  8000181: 'من یک جفت معاملاتی {symbol} در SuperEx ایجاد کرده‌ام! به سوی ماه!',
  8000182: 'مبلغ سود سهام برای هر تراکنش در روز دوشنبه به‌روزرسانی می‌شود، اما ممکن است در فرآیند واقعی توزیع تا 3 روز کاری تأخیر وجود داشته باشد. می‌توانید سوابق مربوطه را در "تاریخچه کیف پول" - "دیگر" - "بازار اصلی" از طریق نوع "ارسال پاداش" بررسی کنید.',
  8000183: 'حساب توییتر',
  8000184: 'اکانت تلگرام',
  8000185: 'حساب دیسکورد',
  8000186: 'لطفاً یک لینک توییتر معتبر وارد کنید!',
  8000187: 'لطفاً یک لینک تلگرام معتبر وارد کنید!',
  8000188: 'لطفاً یک لینک دیسکورد معتبر وارد کنید!',
  8000189: 'لطفاً لینک Twitter را وارد کنید',
  8000190: 'لطفاً لینک Telegram را وارد کنید',
  8000191: 'لطفاً لینک Discord را وارد کنید',
  8000192: 'متأسفانه محتوای قرارداد هوشمند این ارز یا تنظیمات دسترسی مرتبط با آن دارای خطرات امنیتی بالایی است. لطفاً از ارز دیگری استفاده کنید.',
  8000193: 'متأسفانه محتوای قرارداد هوشمند این ارز ممکن است دارای خطرات بالقوه باشد و در حال حاضر نمی‌توان آن را اضافه کرد. لطفاً از ارز دیگری استفاده کنید.',
  8000194: 'توجه:',
  8000195: 'شما باید واریز این توکن را کامل کنید تا بتوانید سفارش فروش را ثبت کنید.',
  8000196: 'شما باید USDT را به حساب Free Market منتقل کنید تا بتوانید سفارش خرید را ثبت کنی',
  8000197: 'شما باید API را متصل کنید تا بتوانید به معاملات بازارسازی بپردازید.',

  8100013: 'کانال تأیید رسمی',
  8100014: 'لطفاً اطلاعات تأیید را وارد کنید',
  8100015: 'می‌توانید محتوای زیر را تأیید کنید',
  8100016: 'فقط ایمیل‌های رسمی از SUPEREX.COM مجاز هستند',
  8100017: 'تأیید هویت BD رسمی',
  8100018: 'مثال: حساب رسمی Telegram/X(Twitter)',
  8100019: 'تأیید کانال لیستینگ',
  8100020: 'اگر نیاز به امضای قرارداد یا پرداخت دارید، لطفاً با BD رسمی تأیید کنید',
  8100021: 'از توجه شما به <a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a> سپاسگزاریم و تمام تلاش خود را می‌کنیم تا از حقوق و منافع همه محافظت کنیم.',
  8100022: 'کانال غیررسمی SuperEx',
  8100023: 'کانال رسمی SuperEx',
  8100024: '<em class="normal activeColor">{keyWord}</em> وارد شده توسط شما کانال رسمی SuperEx نیست. لطفاً امنیت دارایی‌های خود را تضمین کرده و از اطلاعات شخصی خود محافظت کنید.',
  8100025: 'آدرس <em class="normal activeColor">{keyWord}</em> در درخواست شما، {note} است.',
  8100026: 'نکات امنیتی',
  8100027: '· با حساب‌های تأیید نشده تعامل نکنید.',
  8100028: '· عبارات یادآوری کیف پول، ایمیل ثبت شده با SuperEx، شماره تلفن و/یا رمز عبور خود را به کسی ندهید.',
  8100029: '· اگر به کمک بیشتری نیاز دارید، لطفاً با پشتیبانی مشتری به آدرس support@superex.com تماس بگیرید.',
}
export default fa



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/fa.js